import type { ICommand } from '../interfaces/Command';

export class CommandCompound implements ICommand {
  private _commands: Array<ICommand> = [];

  private _isFinalized = false;

  public get isCompound(): boolean {
    return true;
  }

  public get isFinalized(): boolean {
    return this._isFinalized;
  }

  public add(command: ICommand): void {
    this._commands.push(command);
  }

  public async execute(): Promise<undefined | boolean> {
    for (const command of this._commands) {
      await command.execute();
    }
    return true;
  }

  public async undo(): Promise<undefined | boolean> {
    for (let i = this._commands.length - 1; i >= 0; i--) {
      await this._commands[i].undo?.();
    }
    return true;
  }

  public getCommands(): Array<ICommand> {
    return this._commands;
  }

  public finalize(): void {
    this._isFinalized = true;
  }
}
